import { createLogic } from 'redux-logic';
import { FETCH_CONTEXT, FetchContextAction } from './types';
import { fetchContextFulfilled, fetchContextRejected } from './actions';

export const fetchContextLogic = createLogic({
  type: FETCH_CONTEXT,
  latest: true,

  async process({ action }: { action: FetchContextAction }, dispatch, done) {
    try {
      const posContext = await action.payload.getPosContext();

      dispatch(fetchContextFulfilled(posContext));
    } catch (error) {
      dispatch(fetchContextRejected(error as Error));
    }
    done();
  },
});
